import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        lang: localStorage.getItem('lang') === null ? 'es' : localStorage.getItem('lang')
    },
    mutations: {
        changeLang(state, newLang) {
            state.lang = newLang;
            // localStorage.setItem('lang', newLang);
        }
    },
    actions: {}
})
